import React, { createContext, useState, useContext, useEffect } from "react";

const UserIdContext = createContext();

export const UserIdProvider = ({ children }) => {
    const [userId, setUserId] = useState("");

  // Sync userId with localStorage on mount
  useEffect(() => {
    const savedUserId = localStorage.getItem("userId");
    if (savedUserId) {
      setUserId(savedUserId);
    }
  }, []);

  // Update localStorage whenever userId changes
  useEffect(() => {
    if (userId) {
      localStorage.setItem("userId", userId);
    }
  }, [userId]);

  return (
    <UserIdContext.Provider value={{ userId, setUserId }}>
      {children}
    </UserIdContext.Provider>
  );
};

export const useUserId = () => {
  return useContext(UserIdContext);
};
